<template>

    <v-select :model="val" :size="size" @input="val = $event">
        <option value="">{{ label }}</option>
        <option v-for="tz in timezones" :key="tz" :value="tz">{{ tz }}</option>
    </v-select>

</template>

<script>

import moment from 'moment-timezone';

export default {

    props: {
        model: {
            required: true,
        },
        label: {
            type: String,
            default: 'Select Timezone',
        },
        size: {
            type: String,
            default: 'md',
        },
    },

    data() {
        return {
            val: this.model,
            timezones: moment.tz.names(),
        }
    },

    watch: {

        model(val) {
            this.val = val;
        },

        val(val) {
            this.$emit('input', val);
        },

    },

}

</script>
